import { StyleSheet, View } from 'react-native';

import { Skeleton, Text, tokens } from '@fhs/ui';
import { useCRMEventsContext } from '@fhs-legacy/frontend/src/state/crm-events';
import { PAYMENT_ENTRY_SAVED_CARD } from '@fhs-legacy/frontend/src/utils/test-ids';

import { ISavedCardInfo, PaymentMethodType } from '../../../payment/payment-types';
import { logPaymentMethodSelected } from '../../../utils/logging-utils';

import PaymentEntry from './action-payment-method-selection/payment-entry';
import { cardBrandIconMap } from './payment-method-icon-map';

export default function SavedCardEntry({
  loading,
  savedCardInfo,
  selectedPaymentMethod,
  currentSavedCardData,
  setSelectedSavedCard,
  setShowAddPaymentMethod,
  onClose,
}: {
  loading: boolean;
  savedCardInfo: ISavedCardInfo;
  selectedPaymentMethod: PaymentMethodType;
  currentSavedCardData: ISavedCardInfo | undefined;
  setSelectedSavedCard: (cardInfo: ISavedCardInfo) => void;
  setShowAddPaymentMethod: (show: boolean) => void;
  onClose(): void;
}) {
  const { logRBIEvent } = useCRMEventsContext();

  if (!savedCardInfo && loading) {
    return (
      <PaymentEntry
        testID={PAYMENT_ENTRY_SAVED_CARD}
        onPress={() => {
          onClose();
        }}
        icon={<Skeleton style={{ height: 40, width: 40, borderRadius: 30 }} />}
        text="Getting saved info..."
        selected={false}
      />
    );
  }

  if (!savedCardInfo && !loading) {
    return null;
  }

  // Determine if this specific card is selected by comparing accountIdentifiers
  const isThisCardSelected =
    selectedPaymentMethod === 'savedCard' &&
    currentSavedCardData?.accountIdentifier === savedCardInfo.accountIdentifier;

  return (
    <PaymentEntry
      testID={PAYMENT_ENTRY_SAVED_CARD}
      onPress={() => {
        logPaymentMethodSelected(logRBIEvent, `Saved Card ${savedCardInfo.cardType}`);
        setSelectedSavedCard(savedCardInfo);
        setShowAddPaymentMethod(false);
        onClose();
      }}
      icon={cardBrandIconMap[savedCardInfo.cardType]}
      textReplacement={
        <View style={[styles.container]}>
          <Text.Ui
            weight="semibold"
            size="lg"
          >{`${savedCardInfo.cardType} **** ${savedCardInfo.alias}`}</Text.Ui>
          {/* TODO: NEEDS TRASH CAN FOR DELETING CARD INFO  */}
        </View>
      }
      selected={isThisCardSelected}
    />
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
    flexDirection: 'row',
  },
  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
  },
});
